import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export type TextEditorInstance = {
	getHtml: () => string;
	setHtml: (html: string) => void;
};

export type TextEditorProps = {
	editorState: EditorState;
	setEditorState: (editorState: EditorState) => void;
};

export function TextEditor(props: TextEditorProps): JSX.Element {
	return (
		<Editor
			editorState={props.editorState}
			toolbar={toolbarOptions}
			toolbarClassName="toolbarClassName"
			wrapperClassName="wrapperClassName"
			editorClassName="editor-content-container"
			onEditorStateChange={props.setEditorState}
		/>
	);
}

const toolbarOptions = {
	options: ['inline', 'blockType', 'list', 'textAlign', 'link', 'image', 'remove', 'history'],
	inline: {
		inDropdown: false,
		className: undefined,
		component: undefined,
		dropdownClassName: undefined,
		options: ['bold', 'italic', 'underline'],
		bold: { className: undefined },
		italic: { className: undefined },
		underline: { className: undefined },
	},
	blockType: {
		inDropdown: false,
		options: ['Normal', 'H2', 'H3'],
		className: undefined,
		component: undefined,
		dropdownClassName: undefined,
	},
	// fontSize: {
	// 	options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
	// 	className: undefined,
	// 	component: undefined,
	// 	dropdownClassName: undefined,
	// },
	list: {
		inDropdown: false,
		className: undefined,
		component: undefined,
		dropdownClassName: undefined,
		options: ['unordered', 'ordered', 'indent', 'outdent'],
		unordered: { className: undefined },
		ordered: { className: undefined },
		indent: { className: undefined },
		outdent: { className: undefined },
	},

	textAlign: {
		inDropdown: false,
		className: undefined,
		component: undefined,
		dropdownClassName: undefined,
		options: ['left', 'center', 'right', 'justify'],
		left: { className: undefined },
		center: { className: undefined },
		right: { className: undefined },
		justify: { className: undefined },
	},

	link: {
		inDropdown: false,
		className: undefined,
		component: undefined,
		popupClassName: undefined,
		dropdownClassName: undefined,
		showOpenOptionOnHover: true,
		defaultTargetOption: '_blank',
		options: ['link', 'unlink'],
		link: { className: undefined },
		unlink: { className: undefined },
	},

	image: {
		className: undefined,
		component: undefined,
		popupClassName: undefined,
		urlEnabled: true,
		uploadEnabled: true,
		alignmentEnabled: true,
		uploadCallback: undefined,
		previewImage: false,
		inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
		alt: { present: false, mandatory: false },
		defaultSize: {
			height: 'auto',
			width: 'auto',
		},
	},

	remove: { className: undefined, component: undefined },

	history: {
		inDropdown: false,
		className: undefined,
		component: undefined,
		dropdownClassName: undefined,
		options: ['undo', 'redo'],
		undo: { className: undefined },
		redo: { className: undefined },
	},
};
